routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.blog', {
      url: __env.routes.blog,
      template: `<blog sh-ctrl="shCtrl"></blog>`
    })
    .state('home.blogCategory', {
      url: __env.routes.blog,
      template: `<blog sh-ctrl="shCtrl"></blog>`
    })
    .state('home.blogTag', {
      url: __env.routes.blogTag,
      template: `<blog sh-ctrl="shCtrl"></blog>`
    })
    .state('home.blogSearch', {
        url: __env.routes.blogSearch,
        template: `<blog sh-ctrl="shCtrl"></blog>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/blog/blog.config.js